import React from "react";
import { getBrandId, getBrandName } from "../cores/brandCore";

export default function SetBrandLink({ appProps, brand, brandId = getBrandId(brand), brandName = getBrandName(brand) }) {
    if (!appProps) {
        return <div style={{ fontSize: "12px" }}>{brandName}</div>;
    }
    return (
        <a
            onClick={() => {
                appProps?.setSelectedBrandId(brandId);
            }}
            style={{ fontSize: "12px" }}
        >
            {brandName}
        </a>
    );
}
